/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terminology_Guide_OptionalInputs */

const en_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Terminology Guide (Optional)`)
};

const fr_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de terminologie KNP (facultatif)`)
};

const de_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Terminologieleitfaden (optional)`)
};

const it_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida alla terminologia KNP (facoltativa)`)
};

const ru_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справочник по терминологии КНП (необязательно)`)
};

const es_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía de terminología de KNP (opcional)`)
};

const zh_cn2_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP术语指南（可选）`)
};

const ja_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP用語ガイド（オプション）`)
};

const hi_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी शब्दावली मार्गदर्शिका (वैकल्पिक)`)
};

const pt_pt2_knp_terminology_guide_optional = /** @type {(inputs: Knp_Terminology_Guide_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia de Terminologia do KNP (Opcional)`)
};

/**
* | output |
* | --- |
* | "KNP Terminology Guide (Optional)" |
*
* @param {Knp_Terminology_Guide_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terminology_guide_optional = /** @type {((inputs?: Knp_Terminology_Guide_OptionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terminology_Guide_OptionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terminology_guide_optional(inputs)
	if (locale === "de") return de_knp_terminology_guide_optional(inputs)
	if (locale === "it") return it_knp_terminology_guide_optional(inputs)
	if (locale === "ru") return ru_knp_terminology_guide_optional(inputs)
	if (locale === "es") return es_knp_terminology_guide_optional(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terminology_guide_optional(inputs)
	if (locale === "ja") return ja_knp_terminology_guide_optional(inputs)
	if (locale === "hi") return hi_knp_terminology_guide_optional(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terminology_guide_optional(inputs)
	return en_knp_terminology_guide_optional(inputs)
});